import { useState } from 'react'
import {
  gatherHeatmapCardData,
  renderHeatmapCardSVG,
} from '@/share/heatmap-card'
import { shareOrDownload, svgToPngBlob, urlToDataUrl } from '@/share/render'

export default function ShareMonthButton() {
  const [busy, setBusy] = useState(false)
  const [result, setResult] = useState<'shared' | 'downloaded' | 'error' | null>(null)

  const onClick = async () => {
    if (busy) return
    setBusy(true)
    setResult(null)
    try {
      const [data, logoDataUrl] = await Promise.all([
        gatherHeatmapCardData(),
        urlToDataUrl('/logo-256.png'),
      ])
      if (!data.days.some((d) => d.recovery != null)) {
        setResult('error')
        setBusy(false)
        return
      }
      const svg = renderHeatmapCardSVG(data, logoDataUrl)
      const blob = await svgToPngBlob(svg, 1080, 1080)
      const today = new Date().toISOString().slice(0, 10)
      const filename = `lensify-${today}.png`
      const status = await shareOrDownload(blob, filename, {
        title: 'My last 30 days · Lensify',
        text: data.firstName
          ? `${data.firstName}'s last 30 days on Lensify`
          : 'My last 30 days on Lensify',
      })
      setResult(status)
    } catch (err) {
      console.error(err)
      setResult('error')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="flex items-center gap-3">
      <button
        onClick={onClick}
        disabled={busy}
        className="px-4 py-2 rounded-lg bg-brand text-white text-sm font-medium hover:bg-brand-fg disabled:bg-stone-200 disabled:text-stone-400 transition-colors shadow-sm"
      >
        {busy ? 'Creating…' : 'Share last 30 days'}
      </button>
      {result === 'shared' && (
        <span className="text-xs text-green-600">Opened share sheet</span>
      )}
      {result === 'downloaded' && (
        <span className="text-xs text-stone-600">Image downloaded</span>
      )}
      {result === 'error' && (
        <span className="text-xs text-red-600">Not enough data yet</span>
      )}
    </div>
  )
}
